module.exports = __webpack_public_path__ + "img/Chkirate.38a12bd4.jpg";